const VIDEO_EXTENSIONS = [".mp4", ".webm", ".ogg", ".mov", ".m4v"];

export const isVideoUrl = (url = "") => {
  const cleanUrl = String(url).split("?")[0].split("#")[0].toLowerCase();
  return VIDEO_EXTENSIONS.some((extension) => cleanUrl.endsWith(extension));
};

export const getMediaType = (url = "") => (isVideoUrl(url) ? "video" : "image");

export const getMediaFileName = (url = "", fallback = "media-produk") => {
  try {
    const pathname = new URL(url, window.location.origin).pathname;
    const filename = pathname.split("/").filter(Boolean).pop();
    return filename || fallback;
  } catch {
    return fallback;
  }
};
